import simpleRestProvider from "ra-data-simple-rest";

const dataProvider = simpleRestProvider();

export default dataProvider;
